// import "../Pathology/pathology.css";
import "../../Pathology/pathology.css";
import React, { useContext, useEffect, useState, useMemo,useCallback } from "react";
import Table from "../../../components/Table/Table";
import { getModalityList } from "../../../service/MasterService";
import userContext from "../../../context/users/UserContext";
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import './Modality.css';
import { useTranslation } from "react-i18next";
import ColumnsModality from "./ColumnModality";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb";
import CustomSpinner from "../../../components/CustomSpinner";
import loaderContext from "../../../context/loader/LoaderContext";
import ListViewV3 from "../../../components/ListViewV3/ListViewV3";


const Modality = () => {
  const [modalityList, setModalityList] = useState([]);
  const [loading,setLoading] = useState(true);
  const [loadingState, setLoadingState] = useState("");
  const [showToast,setShowToast] = useState(false);
  let listLength = 0;
  const [t, i18n] = useTranslation();
  const { username } = useContext(userContext);
  const {ref, setLoaderRunning} = useContext(loaderContext);

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });


  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try{

      let data = null;
      let pageCount = null;  
      const response = await getModalityList();
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        console.log("--- Res ----",response);
        response.data.data.modalityList.forEach((ele) => {
          if (ele.description == undefined) {
            ele.description = "";
          }
        });
        setModalityList(response.data.data.modalityList);
        listLength = modalityList.length;
        data = response.data.data.modalityList;
        return {
          rows: data,
          pageCount: response.data.data.modalityList.length,
        };
      }else{
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        }
      }
    }catch(e){
      console.log("--- Error ----",e);
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

const columns = ColumnsModality();

const breadCrumbItems = [
  {
    text: t("modality.modality"),
    key: "modality",
  },
];

const handleClick = () =>{
  console.log("in handle click");
}

  return (
    <div className="main-container-body">  
      <ListViewV3 
              buttonsTopBar={[]}
              fetchData = {fetchData}
              columns={columns}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              sortObj = {sortObj}
              setSortObj = {setSortObj}
              setPagination = { setPagination}
              paginationObj = {paginationObj}
              uniqueKey= {"Modality"}
              heading={t("navbar.modalities")}
              showFilter={false}
              enhancedFilter={false}
              showSort={false}
              showPagination = {false}
              extraMargin={false}
              pointer={false}
            />
      </div>  
  );
};

export default Modality;
